import React from 'react';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { CampaignType, siteMapPropType } from '@bingads-webui-react/with-site-map';
import { filterMapItem } from './processor-helpers';

const defaultCampaign = { CampaignType: CampaignType.All };

const updatePageMenuByCampaign = (siteMap, currentCampaign) => {
  const isPmaxCampaignWithStore = currentCampaign && currentCampaign.CampaignSettings &&
    currentCampaign.CampaignSettings[0] && currentCampaign.CampaignSettings[0]['@odata.type'] === '#Model.ShoppingSettings';

  const filter = (item) => {
    if (currentCampaign.CampaignType === 'PerformanceMax' && !isPmaxCampaignWithStore) {
      return item.id !== 'listing-groups' && item.id !== 'products';
    }
    return true;
  };

  return filterMapItem(siteMap, filter);
};

const updatePageMenuByCampaignCached = memoize(updatePageMenuByCampaign);

/**
 * Only for testing
 */
export const testRef = { current: undefined };

export function processPmaxRetailCampaignPageMenu(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const processor = campaign => (<Component
      {...props}
      siteMap={updatePageMenuByCampaignCached(siteMap, campaign)}
    />);

    return (
      <CampaignOData
        call={({ currentCampaign }) => currentCampaign.get()}
        escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : {})}
        fallback={processor(defaultCampaign)}
        onError={() => processor(defaultCampaign)}
        testRef={testRef}
      >
        {campaign => processor(campaign)}
      </CampaignOData>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
  };

  return Wrapper;
}
